import React from "react";
import Toolbar from "devextreme-react/toolbar";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import Form, { SimpleItem } from "devextreme-react/form";
import { Label } from "devextreme-react/data-grid";
import { criarPrintGradeDs } from "../DataSources";
import { DataSource } from "devextreme/data/data_source/data_source";
import api from "../api-axios";
import UserInfo from "../UserInfo";
import ShowError from "../AppServices";
import showReport, { showReportDirect } from "../showReport";
import { SpeedDialAction } from "devextreme-react";

export default class PaginaToolbar extends React.Component {
  constructor(props) {
    super(props);

    this.refFrmXlsx = React.createRef();

    this.state = {
      titulo: props.titulo,
      exibirFilterPanel: false,
      popupExportarXlsxVisivel: false,
    };

    this.exportarXlsx = this.exportarXlsx.bind(this);
    this.confirmarExportarXlsx = this.confirmarExportarXlsx.bind(this);
  }

  onInitialized(e) {
    this.grid = e.component;
  }

  exportarXlsx() {
    this.setState({ popupExportarXlsxVisivel: true, arquivoXlsx: "" });
  }

  confirmarExportarXlsx() {
    this.grid.option("export", {
      enabled: false,
      fileName: this.state.arquivoXlsx,
    });
    this.setState({ popupExportarXlsxVisivel: false });
    this.grid.exportToExcel();
  }

  render() {
    var gridChild = React.Children.only(this.props.children);

    let atualizarCb = this.props.atualizarCb;
    let novoCb = this.props.novoCb;

    if (atualizarCb === undefined && gridChild !== undefined) {
      atualizarCb = () => {
        this.grid.refresh();
      };
    }

    if (
      novoCb === undefined &&
      gridChild !== undefined &&
      !this.props.ocultarNovo
    ) {
      novoCb = () => {
        this.grid.addRow();
      };
    }

    let items = [];

    items.push({
      location: "left",
      className: "top-form-titulo",
      locateInMenu: "never",
      template: () => {
        return `<div class=\'frm-titulo\'>${this.state.titulo}</div>`;
      },
    });

    if (atualizarCb !== undefined) {
      items.push({
        location: "after",
        widget: "dxButton",
        locateInMenu: "auto",
        options: {
          icon: "refresh",
          onClick: atualizarCb,
        },
      });
    }

    if (novoCb !== undefined && !this.props.ocultarNovo) {
      items.push({
        location: "after",
        widget: "dxButton",
        locateInMenu: "auto",
        options: {
          icon: "plus",
          onClick: novoCb,
        },
      });
    }

    if (gridChild !== undefined && !this.props.ocultarExibicaoFiltro) {
      items.push({
        location: "after",
        widget: "dxButton",
        locateInMenu: "always",
        options: {
          icon: "filter",
          text: this.state.exibirFilterPanel
            ? "Ocultar filtro avançado"
            : "Mostrar filtro avançado",
          onClick: function () {
            let valorCorrente = this.grid.option("filterPanel.visible");
            let novoValor = !valorCorrente;
            this.grid.option({
              filterPanel: {
                visible: novoValor,
                enabled: novoValor,
              },
            });
            this.setState({ exibirFilterPanel: novoValor });
          }.bind(this),
        },
      });
    }

    if (gridChild !== undefined && !this.props.ocultarEscolhaColunas) {
      items.push({
        location: "after",
        widget: "dxButton",
        locateInMenu: "always",
        options: {
          icon: "columnchooser",
          text: "Colunas",
          onClick: function () {
            this.grid.option("columnChooser", { mode: "select" });
            this.grid.showColumnChooser();
          }.bind(this),
        },
      });
    }

    if (gridChild !== undefined && !this.props.ocultarExportacao) {
      items.push({
        location: "after",
        widget: "dxButton",
        locateInMenu: "always",
        options: {
          icon: "exportxlsx",
          text: "Exportar (Excel)",
          onClick: this.exportarXlsx,
        },
      });
    }

    const printOptions = this.props.printOptions;

    if (gridChild != null && printOptions != undefined && printOptions.url != undefined) {

      items.push({
        location: "after",
        widget: "dxButton",
        locateInMenu: "always",
        options: {
          icon: "print",
          text: "Imprimir",
          onClick: () => {

            if (printOptions.fnFiltrar != undefined) {
              printOptions.fnFiltrar();
            }

            this.grid.beginCustomLoading("Imprimindo dados");

            let ds = this.grid.getDataSource();

            ds
              .store()
              .load({ filter: this.grid.getCombinedFilter() })
              .done(dadosCompletos => {

                console.log(dadosCompletos);

                let dadosImprimir = dadosCompletos;

                if (printOptions.fnItemConvert != undefined) {
                  dadosImprimir = dadosCompletos.map(printOptions.fnItemConvert);
                }

                const request = {
                  prefeituraId: UserInfo.getPrefeitura(),
                  dadosFiltro: printOptions.fnDadosFiltro == undefined ? undefined : printOptions.fnDadosFiltro(),
                  dadosImprimir: dadosImprimir
                };

                console.log("request", request);

                api.post(printOptions.url, request)
                  .then(resp => {
                    showReportDirect(resp.data.reportStr);
                    this.grid.endCustomLoading();
                  })
                  .catch(error => {
                    ShowError(error.message);
                  });
              });
          }
        },
      });
    }

    var clone = React.cloneElement(gridChild, {
      onInitialized: this.onInitialized.bind(this),
    });

    return (
      <React.Fragment>
        <Toolbar items={this.props.suprimir === true ? [] : items} />
        <Popup
          visible={this.state.popupExportarXlsxVisivel}
          title="Nome do arquivo"
          width={450}
          height={200}
          onHiding={(e) => this.setState({ popupExportarXlsxVisivel: false })}
          onShown={(e) =>
            this.refFrmXlsx.current.instance.getEditor("arquivoXlsx").focus()
          }
        >
          <Form id="frmPesquisa" formData={this.state} ref={this.refFrmXlsx}>
            <SimpleItem dataField="arquivoXlsx">
              <Label visible={false} />
            </SimpleItem>
          </Form>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="after"
            options={{
              text: "Fechar",
              width: 150,
              onClick: () => this.setState({ popupExportarXlsxVisivel: false }),
            }}
          />
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="after"
            options={{
              text: "Salvar",
              type: "success",
              width: 150,
              onClick: () => this.confirmarExportarXlsx(),
            }}
          />
        </Popup>
        {clone}
      </React.Fragment>
    );
  }
}
